/**
 * use-ai-perms.ts — Quyền Nhân viên AI theo vai trò động (BRD §5.3.1: không có quyền → không hiện nút).
 * Backend đòi `ai.view` để xem, `ai.update` để tạo / sửa / xoá / phát hành nhân viên AI, kịch bản, kiểm định,
 * nguồn AI, lỗ hổng kiến thức (ai-bot-routes, bot-version-routes, scenario-routes, ai-eval-routes,
 * ai-sources-routes, ai-credit-routes, knowledge-gap-routes) — không theo tên vai trò.
 * Đang tải danh sách quyền → coi như chưa có quyền. `loaded` = đã tải xong.
 */
import { useMyPermissions } from '@/hooks/use-settings'

export function useAiPerms(): { canView: boolean; canEdit: boolean; loaded: boolean } {
  const { data: perms } = useMyPermissions()
  return {
    canView: !!perms?.has('ai.view'),
    canEdit: !!perms?.has('ai.update'),
    loaded: !!perms,
  }
}
